import Api from "../../../config/api";
import {
  CREATE_LEAD,
  DELETE_LEAD_SOFT,
  GET_LEAD_STATUS_COUNT,
  SEARCH_LEAD,
  SEARCH_LEAD_BY_ID,
  UPDATE_LEAD,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getLead = async (params: any) => {
  try {
    const res = await Api(false).get(SEARCH_LEAD, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getLeadById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_LEAD_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createLead = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_LEAD, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateLead = async (
  body: any,
  id: string,
  hideLoader?: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_LEAD}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader?.();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader?.();
    }
  }
};

export const getLeadStatusCount = async () => {
  try {
    const res = await Api(false).get(GET_LEAD_STATUS_COUNT);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const restoreLead = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).delete(`${DELETE_LEAD_SOFT}`, {
      data: body,
    });
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
